










































import Vue from 'vue';
import axios from 'axios';
import { Region, User } from '@/types';
import { Utils } from '@/Utils';

interface Data {
    user?: User;
    regions: string[];
    selectedRegions: string[];
}

export default Vue.extend({
    data(): Data {
        return {
            user: undefined,
            regions: Object.values(Region),
            selectedRegions: [],
        };
    },
    methods: {
        beforeOpen(e) {
            this.selectedRegions = [...e.params.user.regions];
            this.user = e.params.user;
        },
        selectRegion(e, region) {
            if (e.target.checked) {
                this.selectedRegions.push(region);
            } else {
                this.selectedRegions = this.selectedRegions.filter(
                    reg => reg !== region
                );
            }
        },
        handleSave() {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/user/regions`, {
                    userId: this.user.userName,
                    regions: this.selectedRegions,
                })
                .then(res => {
                    this.user.regions = res.data;
                    this.$modal.hide('regions');
                })
                .catch(err => {
                    Utils.toastError('Something went wrong. Try again later.');
                });
        },
    },
});
